import { COLORS } from '@btime/constants'
import { formatDate, fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Text } from '../../../../../components/presentation/Text'
import { UserAvatar } from '../../../../../components/presentation/Avatar'
import { formatRunningTime } from '../../../../../utils/helpers/date'
import { translateLog } from '../../../_locales/logKeyGenerator'
import { useCurrentModal } from '../../../../../components/modals/ModalsContext'
import { useLogs } from './_load/StacktraceLoader'
import { useOpenLogModal } from '../../../../../utils/routes/modals/modalsActions'
import { useSetTabByName } from '../../../../../components/tabs/TabsContext'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import LevelTag from '../../../_shared/LevelTag'
import Link from '../../../../../components/actions/Link'
import OriginTag from '../../../_shared/OriginTag'
import Panel from '../../../../../components/structure/Panel'
import Separator from '../../../../../components/helpers/Separator'

const LogItem = ({ log, selected }) => {
  const { t } = useTranslation(['logs', 'common'])

  const openDetailsModal = useOpenLogModal()
  const setTab = useSetTabByName()

  const handleClick = () => {
    setTab('Detalhes')
    openDetailsModal(log)
  }

  const color = selected ? COLORS.dark2 : COLORS.light3
  const bgColor = selected && COLORS.light1

  return (
    <Link onClick={handleClick} block>
      <Panel lineBorder noMargin smallPadding borderLeftColor={color} bgColor={bgColor}>
        <Text weight="500">{translateLog(t, log)}</Text>

        <Separator weight={2} />

        <FlexGrid justify="space-between" gutter={0.3}>
          <SmallText size="xsmall">
            {formatDate('DD/MM/YY HH:mm:ss', log.happenedAt)} ({fromNow(log.happenedAt)})
          </SmallText>
          <SmallText size="xsmall">{formatRunningTime(log.executionTime)}</SmallText>

          <FlexCol flex={1} />

          <LevelTag level={log.level} size="xxxsmall" />
          <OriginTag origin={log.origin} size="xxxsmall" />
          <UserAvatar size="xsmall" user={log.user} />
        </FlexGrid>
      </Panel>
    </Link>
  )
}

const StacktraceList = () => {
  const logs = useLogs()
  const { data: log } = useCurrentModal()

  return (
    <FlexGrid direction="column" gutter={0.3} align="stretch" justify="flex-start">
      {logs.map(item => (
        <LogItem key={item.id} log={item} selected={log._id === item._id} />
      ))}
    </FlexGrid>
  )
}

export default StacktraceList
